/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { Button } from 'antd';
// import Axios from 'axios';
// import config from '../../../Config/key';
import { logoutUser } from '../../../../_actions/user_actions';
// 簡易ログイン（メール未確認）セッションではパスワード変更を行えない
import { isTrialQuickSession } from '../../../../utils/trialGuard';
import { withRouter } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

function RightMenu(props) {
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();

  const logoutHandler = () => {
    // axios.get(`${config.USER_SERVER}/logout`).then((response) => {
    //   if (response.status === 200) {
    //     props.history.push('/login');
    //   } else {
    //     alert('Log Out Failed');
    //   }
    // });
    dispatch(logoutUser()).then((response) => {
      //Not Loggined in Status
      // if (!response.payload.isAuth) {
      //   if (option) {
      //     props.history.push('/login');
      //   }
      //   //Loggined in Status
      // } else {
      //   //supposed to be Admin page, but not admin person wants to go inside
      //   if (adminRoute && !response.payload.isAdmin) {
      //     props.history.push('/');
      //   }
      //   //Logged in Status, but Try to go into log in page
      //   else {
      //     if (option === false) {
      //       props.history.push('/');
      //     }
      //   }
      // }
      // console.log({ response });
      props.history.push('/login');
    });
  };

  // const changePasswordHandler = async () => {
  //   // e.preventDefault();
  //   try {
  //     const data = {
  //       user: user.userData,
  //       password: '123456',
  //     };
  //     // console.log({ data });
  //     const res = await Axios.patch(`${config.USER_SERVER}/pc`, data);
  //     if (res.data.success) {
  //       // await readDB();
  //       message.success('パスワードを変更しました。');
  //       props.history.push('/');
  //     }
  //     console.log(res);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  if (!user.userData) return null;

  // ナビバー右側アクション（ショーケース §17「ナビゲーション」整合 / Ph.6 6 次）。
  //   従来は antd <Menu> のリンク項目だった「パスワード変更 / ログアウト」を <Button> 化し、
  //   §17 のアクションボタン配色（AA 安全な濃い青 = --blue-active）に統一する。
  //   mode に応じて配置を切り替える:
  //     horizontal（デスクトップ）= 横並び / inline（モバイル Drawer）= 縦積み・フル幅
  const isInline = props.mode === 'inline';
  const wrapperClassName = isInline
    ? 'menu__actions menu__actions--inline'
    : 'menu__actions';

  if (user.userData && !user.userData.isAuth) {
    // 未ログイン状態: ログインボタンのみ
    return (
      <div className={wrapperClassName}>
        <Button href="/login" className="navbar-action-btn" block={isInline}>
          ログイン
        </Button>
      </div>
    );
  }

  // ログイン済み状態: パスワード変更・ログアウト
  // ただし簡易ログイン（メール未確認）セッションでは、パスワード変更ができないため
  // ボタン自体を表示しない（サーバー側でも 403 でブロックされる）。
  const isQuickSession = isTrialQuickSession(user);
  return (
    <div className={wrapperClassName}>
      {isQuickSession ? null : (
        <Button href="/cp" className="navbar-action-btn" block={isInline}>
          パスワード変更
        </Button>
      )}
      <Button onClick={logoutHandler} className="navbar-action-btn" block={isInline}>
        ログアウト
      </Button>
    </div>
  );
}

export default withRouter(RightMenu);
